import { Component, OnInit } from '@angular/core';
import {NavController} from '@ionic/angular';
import { GlobalVars } from '../../../../providers/globalVars';
import { ActivatedRoute,Router } from '@angular/router';
@Component({
  selector: 'app-chargeconfirm',
  templateUrl: './chargeconfirm.page.html',
  styleUrls: ['./chargeconfirm.page.scss'],
})
export class ChargeconfirmPage implements OnInit {
  pitemid:any;
  constructor(public navCtrl:NavController,private route: ActivatedRoute,private gv: GlobalVars,private router:Router) { }

  ngOnInit() {
    if(this.route.snapshot.paramMap.get('id'))
      this.pitemid = this.route.snapshot.paramMap.get('id');
  }
  back(){
    if(this.pitemid)
      this.navCtrl.navigateBack('/tabs/pm/pitemcheckout/'+this.pitemid);
    else
      this.router.navigate(['/tabs/pfmenu/mypoint'])
  }
}
